export const API = process.env.REACT_APP_API_URL;
export const KEY = process.env.REACT_APP_SECRET_ENCRYPTION_KEY;
export const GEOLINK = process.env.REACT_APP_GEOPORTAL_LINK;
export const OBSERVATORYLINK = process.env.REACT_APP_OBSERVATORY_LINK;
export const DRIVELINK = process.env.REACT_APP_DRIVE_LINK;
export const defaultError = {
    error: true,
    response: "Ha ocurrido un error, intente nuevamente"
};
export const config = {
    headers:{
        'Content-Type': 'application/json',
        Authorization: window.localStorage.getItem("tokenUser")
    }
};
export const closeSession = () => {
    alert("Sesión expirada, por favor vuelva a iniciar sesión");
    window.localStorage.clear();
    window.location.assign("/");
}
